const cache = {};

export default function getLatLong(query, countryCode) {
  if (query in cache) return cache[query];

  cache[query] = fetch(`https://api.opencagedata.com/geocode/v1/json?q=${query}&key=${window.api.public_guides_key}&language=en&countrycode=${countryCode}`).then(res => res.json()).then(data => {
    if (!data.results.length) return null;

    const match = data.results[0];

    return {
      latitude: match.geometry.lat,
      longitude: match.geometry.lng,
    };
  });

  return cache[query];
}
